import { render, staticRenderFns } from "./BarGraph.vue?vue&type=template&id=2dcdc564&scoped=true&"
import script from "./BarGraph.vue?vue&type=script&lang=js&"
export * from "./BarGraph.vue?vue&type=script&lang=js&"
import style0 from "./BarGraph.vue?vue&type=style&index=0&id=2dcdc564&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcdc564",
  null
  
)

component.options.__file = "BarGraph.vue"
export default component.exports